import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu } from "lucide-react";
import { Sidebar } from "@/components/Sidebar";
import { Button } from "@/components/ui/Button";

export function AppLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [prevPathname, setPrevPathname] = useState(location.pathname);

  if (location.pathname !== prevPathname) {
    setPrevPathname(location.pathname);
    setMobileNavOpen(false);
  }

  return (
    <div className="flex h-screen bg-background">
      {mobileNavOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={() => setMobileNavOpen(false)}
        />
      )}
      <Sidebar open={mobileNavOpen} />
      <main className="flex-1 overflow-y-auto">
        <div className="sticky top-0 z-20 flex h-10 items-center bg-background px-2 md:hidden">
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={() => setMobileNavOpen((v) => !v)}
            aria-label={t("nav.openMenu")}
            title={t("nav.openMenu")}
          >
            <Menu />
          </Button>
        </div>
        <div className="max-w-5xl px-6 pt-6 pb-10 md:pt-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
